var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkIcon17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Export-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Cancel-Upload",
    fillOpacity: 0.2,
    cx: 8.5,
    cy: 8.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35 6.904h.98c.043-.606.465-.99 1.118-.99.649 0 1.07.379 1.07.9 0 .478-.203.748-.776 1.094-.65.388-.938.815-.914 1.497l.004.36h.98V9.48c0-.478.176-.729.787-1.089.625-.374.995-.89.995-1.62C10.594 5.744 9.75 5 8.5 5c-1.373 0-2.107.815-2.15 1.904zM8.382 12c.436 0 .73-.289.73-.72 0-.44-.294-.73-.73-.73s-.734.29-.734.73c0 .431.298.72.734.72z",
    id: "?"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon17);
export default __webpack_public_path__ + "static/media/question-mark-icon-17.bdbb6d15.svg";
export { ForwardRef as ReactComponent };